module.exports = __webpack_public_path__ + "img/header-apppath.9a11371b.png";